import React from "react";
import { Link } from "react-router-dom";

function CustomLink(props) {
  return (
    <Link
      to={props.to}
      onClick={() => {
        if (props.hasOnClick) {
          props.onClick();
        }
      }}
      className="link mx-2 blue"
    >
      {props.text}
    </Link>
  );
}

export default CustomLink;
